import React, { useEffect, useState,useContext,useRef, useCallback } from "react";
import Vitrine from "./Vitrine";
import Filtres from "./filtres/Filtres";
import {BrowserView, MobileView,isMobile, isBrowser} from 'react-device-detect';
import { AppContext, UserContext } from "../../AppContextProvider";
import { VitrineContext } from "./VitrineContext";
import Une from "../une/Une";
import { useFetch } from "../api/FetchApiData";
import ChatBot from "../chatbot/ChatBot";
import { useInfiniteScroll } from "../utils/InfiniteScroll";
import { useNavigate } from "react-router-dom";
import { useWindowHeight } from "@react-hook/window-size";
if (isMobile)
    import('./vitrines_mob.css').then(() => {});
else
    import('./vitrines.css').then(() => {});

export default function Vitrines()
{
    const [UserState,setUserState] = useContext(UserContext);
    const fetchData = useFetch();
    const [vitrines,setVitrines] = useContext(VitrineContext);
    const navigator = useNavigate();
    const height = useWindowHeight();
    const [hasMore,setHasMore] = useState(true);
    const [PricesHistogram,setPricesHistogram] = useState({reloaded:true,histogram:{}});

    const FetchVitrines = useCallback(async ()=>{
        if (!hasMore)
            return
        let params = new URLSearchParams({
            page:vitrines.page,
        });
        Object.keys(vitrines.filters).map((key)=>{
            params.append(key,vitrines.filters[key])
        })
        fetchData.GetData(`vitrines/?${params}`).then((result)=>{
            if(result.result && vitrines.page>=result.maxpage)
            {
                if(vitrines.page>=result.maxpage)
                    setHasMore(false);             
                if(PricesHistogram.reloaded)
                {
                    setVitrines({...vitrines,page:vitrines.page+1,articles:[...vitrines.articles,...result.vitrines],histogram:result.histogram});
                    setPricesHistogram({reloaded:false,histogram:result.histogram});
                }
                else
                {
                    setVitrines({...vitrines,page:vitrines.page+1,articles:[...vitrines.articles,...result.vitrines]});
                }
                /*
                else
                {
                    
                }
                */
            }
        });
        
    },[hasMore])

    const LoadMoreRef = useInfiniteScroll(FetchVitrines,hasMore);


    const BtnNewItem = ()=>
    {
        if(UserState.is_staff)
            return(
                <div style={{textAlign:'center',width:'100%'}}>
                    <input onClick={e=>{navigator('/add-product/')}} className="AddItem" type="button" value='Nouvel Article' />
                    <input style={{backgroundColor:'lightblue',marginLeft:'5px'}} onClick={e=>{navigator('/promos/')}} className="AddItem" type="button" value='Promos' />
                </div>
            );
        else
            return
    }
    
    const Page=()=>
    {
        return(
            <div style={{width:'100%'}}>
                <MobileView>
                    {BtnNewItem()}
                </MobileView>
                {vitrines.articles.map((item,index)=>{    
                    return <Vitrine key={index} article={item} />;
                })}
                <div ref={LoadMoreRef} style={{height:'20px'}}/>
            </div>
        );
    }

    useEffect(()=>{
        if(!hasMore)
        {setHasMore(true);setPricesHistogram({...PricesHistogram,reloaded:true});}
    },[vitrines.filters])


    return(
        <div id="Vitrines">
            <BrowserView>
                <Une />
                <div style={{height:'max-content'}}> 
                    <div id="Filtres">
                        {BtnNewItem()}
                        <Filtres histogram={vitrines.histogram}/>
                    </div>
                    <div id="Produits">
                        {Page()}
                    </div>
                </div>
                <ChatBot />
            </BrowserView>
            <MobileView>
                <div id="Produits" style={{minHeight:height}}>
                    <Une /> 
                    {Page()}
                </div>
            </MobileView>
        </div>
    );
}
